import billingModule from '../../billing.module';
import template from './billingPreview.component.html';
import style from './billingPreview.component.css';

export default billingModule.component('billingPreview', {
    template,
    style,
    controller(
        asLoadingMask,
        asNotifier,
        billingColorConstants,
        billingPreviewService,
        textResources
    ) {
        var vm = this;

        vm.billingColorConstants = billingColorConstants;

        vm.$onInit = () => {
            asLoadingMask.show();

            billingPreviewService
                .getUpcomingCharges()
                .then(
                    data => {
                        vm.rows = data.rows;
                    },
                    () => {
                        asNotifier.error(
                            `${textResources.getUpcomingChargesFailed} ${
                                textResources.ifProblemPersists
                            }`
                        );
                    }
                )
                .finally(() => {
                    asLoadingMask.hide();
                });
        };
    }
});



// WEBPACK FOOTER //
// ./modules/billing/components/billing-preview/billingPreview.component.js